module.exports = __webpack_public_path__ + "img/kita-kunterbunt-building.135aca19.jpg";